import {
  validatePresence,
  validateLength,
} from 'ember-changeset-validations/validators';

export default {
  summary: [
    validatePresence({ presence: true, message: "Can't be blank" }),
    validateLength({
      max: 255,
      message: "Can't be longer than 255 characters",
    }),
  ],
};
